/**
 * Handles all radios and checkboxes to be togglable with enter key
 * @module enterable
 */

import $ from 'jquery';
import Keyboard from './keyboard';
import registerJQueryPlugin from '../lib/register-jquery-plugin';
import mergeOptions from '../lib/merge-options';
// Expose the function as a jQuery plugin for ease of use
export const PLUGIN_NAME = 'enterable';
export const DEFAULTS = {};

/**
 * Applies any sort of event handlers for the checkboxes or radios.
 * @param  {jQuery} $el - checkbox / radio
 * @param  {Object} [options={}] - Any options provided upon initialization
 */
const setEventListeners = ($el, options = {}) => {
  $el.on('keydown.enterable', evt => {
    if (Keyboard.parseKey(evt) === Keyboard.keys.ENTER) {
      $el.trigger('click');
    }
  });
};
/**
 * Initializes enterable.
 * @param {HTMLElement} el - button /element that opens enterable
 * @param {Object} options - Options used for wiring up the enterable
 * @param {Object} deregister - Performs a deregisteration on the plugin
 * @see DEFAULTS
 */
export default function enterable(el, options = {}, { deregister }) {
  const $el = $(el);
  const opts = mergeOptions($el, options);
  setEventListeners($el, opts);
}
registerJQueryPlugin(PLUGIN_NAME, enterable);



// WEBPACK FOOTER //
// ./styleguide/src/assets/modules/enterable.js